<template>
  <div
    v-on-clickaway="close"
  >
    <div
      class="select-autocomplete"
      :class="{ 'select-autocomplete_error': error }"
    >
      <div class="select-autocomplete__field">
        <input
          v-bind="$attrs"
          :value="value"
          type="text"
          class="select-autocomplete__field-input"
          placeholder=" "
          @input="onInput($event.target.value)"
          @click="isShow = !isShow"
          @focus="error = false"
        >
        <label
          v-if="label"
          class="select__label"
        >
          {{ label }}
          <span v-if="required" class="select__label-required">*</span>
        </label>
      </div>
      <ul
        v-show="isShow"
        class="select-autocomplete__results"
      >
        <li
          v-for="(result, i) in filteredItems"
          :key="i"
          class="select-autocomplete__result"
          @click="setResult(result)"
        >
          {{ result.text }}
        </li>
      </ul>
      <transition name="slide-from-top">
        <span
          v-if="error && errorMsg"
          class="input__error-msg"
        >
          {{ errorMsg }}
          <ErrorIcon/>
        </span>
      </transition>
    </div>
  </div>
</template>

<script>
  import { mixin as clickaway } from 'vue-clickaway'
  import ErrorIcon from '@/assets/img/icons/error.svg?inline'

  // import { config } from '@/config'
  // import debounce from 'lodash/debounce'

  export default {
    name: 'BaseAutoComplete',
    components: {
      ErrorIcon
    },
    mixins: [ clickaway ],
    props: {
      required: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: ''
      },
      items: {
        type: Array,
        default: () => []
      },
      placeholder: {
        type: String,
        default: ''
      },
      errorMsg: {
        type: String,
        default: ''
      },
      scrollbar: {
        type: String,
        default: 'custom'
      }
    },
    data () {
      return {
        error: null,
        isShow: false,
        value: '',
        results: []
      }
    },

    computed: {
      filteredItems () {
        if (this.value.length === 0) {
          return this.items
        }
        return this.items.filter(item => item.text.toLowerCase().indexOf(this.value.toLowerCase()) > -1)
      }
    },

    watch: {
      errorMsg: {
        handler (msg) {
          this.error = !!msg
        },
        immediate: true
      }
    },
    created () {
      this.value = ''
    },
    methods: {
      onInput (value) {
        this.$emit('input', value)
        const app = this
        app.value = value
      },

      setResult (result) {
        this.value = result.value
        this.$emit('input', this.value)
        this.isShow = false
      },
      close () {
        this.isShow = false
      }
    }
  }
</script>

<style lang="scss">
.select-autocomplete {
  position: relative;
  min-width: 290px;
  padding-bottom: 28px;
  margin-bottom: 10px;

  &__field {
    cursor: pointer;
    position: relative;

    &::after {
      position: absolute;
      top: 50%;
      right: 5%;
      display: inline-block;
      width: 1.5em;
      height: 1.5em;
      padding-top: 0.25em;
      color: #fff;
      text-align: center;
      content: "!";
      background-color: $c-active;
      border-radius: 50%;
      opacity: 0;
      transition: opacity 0.3s;
      transform: translateY(-50%);
    }

    &-input {
      position: relative;
      display: block;
      width: 100%;
      min-height: 58px;
      padding: 27.5px 19px 8px 16px;
      font-family: "ToyotaType-Book", Arial, Helvetica, sans-serif;
      font-size: 16px;
      line-height: 1;
      background-color: $c-white;
      border: 1px solid $c-gray-4;
      outline: none;
      caret-color: $c-active-light;
      transition: 0.3s;
      appearance: none !important;
      -webkit-appearance: none !important;
      border-radius: 0 !important;

      &:focus {
        background-color: $c-gray-1;
      }

      @include hover {
        background-color: $c-gray-1;

        + .select__label {
          color: $c-gray-dark;
        }
      }

      &:focus ~ .select__label,
      &:not(:placeholder-shown) ~ .select__label {
        top: 11px;
        font-size: 13px;
        transform: translateY(0);

        @include mobile {
          font-size: 11px;
        }
      }
    }
  }

  &__results {
    cursor: pointer;
    max-height: 270px;
    overflow: auto;
    list-style: none;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    box-shadow: 2px 2px 5px rgba($c-black, 0.1);
    transition: 0.3s;
    -webkit-overflow-scrolling: touch;
    position: absolute;
    top: calc(100% - 28px);
    left: 0;
    z-index: 999;
    width: 100%;
    border-bottom: 1px solid $c-gray-4;

    @include custom-scrollbar-inputs();
  }

  &__result {
    padding: 16px;
    font-size: 16px;
    line-height: 1.5;
    color: #333;
    background-color: $c-white;
    border: 1px solid $c-gray-4;
    border-bottom: 0;
    transition: background-color 0.3s;

    &:first-child {
      border-top: 0;
    }

    @include hover {
      background-color: $c-gray-1;
    }
  }

  &_error {
    .select-autocomplete__field-input {
      border: 1px solid $c-errorDark;
    }
  }
}

</style>
